import type { ReactNode } from 'react';
import {
  Button,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  FluentProvider,
  OverlayDrawer,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { useActiveTheme, useIsMobile } from '@moko/ui';

export interface PricingParameterDrawerProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  size?: 'medium' | 'large';
}

const PricingParameterDrawer = ({
  open,
  title,
  onClose,
  children,
  size = 'medium',
}: PricingParameterDrawerProps) => {
  const theme = useActiveTheme();
  const isMobile = useIsMobile();

  return (
    <FluentProvider theme={theme}>
      <OverlayDrawer
        open={open}
        onOpenChange={(_, data) => {
          if (!data.open) onClose();
        }}
        position="end"
        size={isMobile ? 'full' : size}
      >
        <DrawerHeader>
          <DrawerHeaderTitle
            action={
              <Button
                appearance="subtle"
                aria-label="Close"
                icon={<Dismiss24Regular />}
                onClick={onClose}
              />
            }
          >
            {title}
          </DrawerHeaderTitle>
        </DrawerHeader>
        <DrawerBody>{open && children}</DrawerBody>
      </OverlayDrawer>
    </FluentProvider>
  );
};

export default PricingParameterDrawer;
